export default {
    csManagement: {
        page: {
            title: 'CS 管理中心',
            description: '管理租戶配額、文件總量和 Token 消耗控制',
        },
        quota: {
            searchPlaceholder: '搜尋租戶 ID',
            typePlaceholder: '配額類型',
            search: '搜尋',
            create: '新增配額',
            tenantId: '租戶 ID',
            quotaType: '配額類型',
            typeDocument: '文件總量',
            typeToken: 'Token 消耗總量',
            quotaLimit: '配額上限',
            quotaUsed: '已使用',
            contractPeriod: '合約期',
            contractStart: '合約開始',
            contractEnd: '合約結束',
            status: '狀態',
            statusActive: '生效中',
            statusExpired: '已過期',
            remark: '備註',
            action: '操作',
            edit: '編輯',
            delete: '刪除',
            createTitle: '新增配額',
            editTitle: '編輯配額',
            cancel: '取消',
            confirm: '確認',
            saving: '儲存中...',
            featureConfig: '功能配置',
            featureConfigTitle: '功能權限配置',
            featureQuotaSectionTitle: '功能次數上限',
            featureQuotaSectionDesc: '設定合約週期內各功能可建立次數，-1 表示不限制，0 表示關閉功能',
            featureDisclosure: '交底書',
            featureDisclosureLimit: '交底書上限',
            featureDisclosureDesc: '發明交底書撰寫功能',
            featurePatentDraft: '專利申請',
            featurePatentDraftLimit: '專利申請上限',
            featurePatentDraftDesc: '專利申請文件撰寫功能',
            featureProsecution: 'OAR答覆',
            featureProsecutionLimit: 'OAR答覆上限',
            featureProsecutionDesc: '審查意見答覆撰寫功能',
            featureLimitHint: '* -1 表示不限制，0 表示關閉該功能',
            featureLimitExceeded: '功能次數總和 {total} 不能超過配額上限 {limit}',
            featureUsed: '已使用',
            featureRemaining: '剩餘',
            featureReachedLimit: '已達上限',
            featureLimitBelowUsedWarning: '上限低於已用次數',
            featureDisabled: '已關閉',
            userQuotaTitle: '使用者配額明細',
            userQuotaHint: '公司配額上限：{limit} 次',
            userEmail: '使用者郵箱',
            unlimited: '不限制',
            addUser: '新增使用者',
            addUserPlaceholder: '輸入使用者郵箱',
            reset: '清除',
            deleteUserQuotaConfirmTitle: '確認刪除該使用者的個人配額配置？',
            deleteUserQuotaConfirmDesc: '刪除後該使用者將不再顯示在使用者配額明細中，個人功能次數限制恢復為未配置狀態。',
            tenantName: '公司名稱',
            configuredMembers: '已配置員工',
            noConfiguredMembers: '該公司暫無已配置員工',
            tenantInfoNotFound: '未找到該公司',
            tenantInfoFailed: '查詢失敗，請稍後重試',
            featureList: '功能清單',
            featureAll: '全部',
        },
    },
};
